import PropTypes from 'prop-types';
import styles from './FJMobileCreaseEdit.module.less';
import FJUndoIcon from '../../../assets/svg/undo.svg?react';
import FJRedoIcon from '../../../assets/svg/redo.svg?react';
import FJResetIcon from '../../../assets/svg/reset.svg?react';
import FJBrushIcon from '../../../assets/svg/brush.svg?react';
import FJMobileSlider from '../../../common/components/FJMobileSlider/FJMobileSlider';
import FJEraserIcon from '../../../assets/svg/eraser.svg?react';
import FJHoverBoardGradation from '../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import { MOUSE_EVENT_TYPE } from '../../FJMainPreview/FJCreationEditPanel/js/FJViewCanvas';
import classNames from 'classnames';
const MAX_SIZE = 42;
const MIN_SIZE = 8;
const FJMobileCreaseEdit = props => {
    const {
        // disabled,
        brashSize,
        curBrushType,
        isMouseMove,
        isSlideCompare = false,
        changeBrushType,
        changeBrashSize,
        minBrashSize = MIN_SIZE,
        maxBrashSize = MAX_SIZE,
        hasUndo,
        hasRedo,
        disableReset,
        undoHandler,
        redoHandler,
        resetHandler,
        switchScratchOrFold,
    } = props;
    return (
        <div className={classNames(styles.crease_box, { [styles.disabled]: !switchScratchOrFold })}>
            <div className={styles.crease_content}>
                <div className={styles.crease_content_left}>
                    <div
                        className={classNames(styles.crease_left_item, {
                            [styles.disabled]: !hasUndo || !switchScratchOrFold,
                        })}
                        onClick={undoHandler}
                    >
                        <FJUndoIcon />
                    </div>
                    <div
                        className={classNames(styles.crease_left_item, {
                            [styles.disabled]: !hasRedo || !switchScratchOrFold,
                        })}
                        onClick={redoHandler}
                    >
                        <FJRedoIcon />
                    </div>
                    <div
                        className={classNames(styles.crease_left_item, {
                            [styles.disabled]: disableReset || !switchScratchOrFold,
                        })}
                        onClick={resetHandler}
                    >
                        <FJResetIcon />
                    </div>
                </div>
                <div
                    className={classNames(styles.crease_content_right, {
                        [styles.disabled]: !switchScratchOrFold,
                    })}
                >
                    <FJHoverBoardGradation
                        className={styles.crease_right_item}
                        contentClassName={styles.crease_right_item_box}
                        active={curBrushType === MOUSE_EVENT_TYPE.MASK_DRAW && !isMouseMove && !isSlideCompare}
                        selectBgColor={'#fff'}
                        borderRadius={20}
                        onClick={() => changeBrushType(MOUSE_EVENT_TYPE.MASK_DRAW)}
                    >
                        <FJBrushIcon />
                    </FJHoverBoardGradation>
                    <FJHoverBoardGradation
                        className={styles.crease_right_item}
                        contentClassName={styles.crease_right_item_box}
                        active={curBrushType === MOUSE_EVENT_TYPE.MASK_ERASE && !isMouseMove && !isSlideCompare}
                        borderRadius={20}
                        selectBgColor={'#fff'}
                        onClick={() => changeBrushType(MOUSE_EVENT_TYPE.MASK_ERASE)}
                    >
                        <FJEraserIcon />
                    </FJHoverBoardGradation>
                </div>
            </div>
            <FJMobileSlider
                className={classNames(styles.crease_slider, {
                    [styles.disabled]: !switchScratchOrFold,
                })}
                max={maxBrashSize}
                min={minBrashSize}
                value={brashSize}
                onChange={changeBrashSize}
            />
        </div>
    );
};

FJMobileCreaseEdit.propTypes = {
    disabled: PropTypes.bool,
    brashSize: PropTypes.number,
    curBrushType: PropTypes.string,
    isMouseMove: PropTypes.bool,
    isSlideCompare: PropTypes.bool,
    changeBrushType: PropTypes.func,
    changeBrashSize: PropTypes.func,
    // disabled: PropTypes.bool,
    minBrashSize: PropTypes.number,
    maxBrashSize: PropTypes.number,
    hasUndo: PropTypes.bool,
    hasRedo: PropTypes.bool,
    undoHandler: PropTypes.func,
    redoHandler: PropTypes.func,
    resetHandler: PropTypes.func,
    disableReset: PropTypes.bool,
    switchScratchOrFold: PropTypes.bool,
};
export default FJMobileCreaseEdit;
